<template>
    <!-- The Modal -->
    <b-modal
        id="stock-message"
        title="Send Stock Message"
        v-model="modalOpen"
        no-fade
        size="lg"
        @change="onModalChange"
        @hide="onModalChange"
        @show="onModalChange">
        <template v-slot:modal-footer>
            <b-btn @click="cancelModal">Cancel</b-btn>
            <b-btn :disabled="!selectedUserIds.length" :title="selectedUserIds.length ? '' : 'Add some users to send.'" @click="submit()">Send</b-btn>
        </template>
        <div class="row">
            <div class="col-md-12">
                <input type="text" name="emailSubject" id="emailSubject" v-model="notifySubject" />
            </div>
            <div class="col-md-12">
                <textarea name="emailMessage" id="emailMessage" v-model="notifyMessage">
                    {{ notifyMessage }}
                </textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div v-if="userList && userList.length">
                    <!-- Select All checkbox remains at top level -->
                    <div class="row detail mb-3">
                        <div class="col-md-1">
                            <b-checkbox v-model="selectAll"></b-checkbox>
                        </div>
                        <div class="col-md-11 select-all-checkbox">
                            Select All users
                        </div>
                    </div>
                    
                    <!-- New Accordion structure -->
                    <div class="accordion" role="tablist">
                        <b-card v-for="(users, repName, index) in repGroupedUsers" 
                                :key="index" 
                                no-body 
                                class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle="`accordion-${index}`" variant="info">{{ repName }}</b-button>
                            </b-card-header>
                            <b-collapse :id="`accordion-${index}`" accordion="my-accordion" role="tabpanel" :visible=false>
                                <b-card-body>
                                    <div class="row detail mb-3">
                                        <div class="col-md-1">
                                            <b-checkbox 
                                                v-model="repSelectAll[repName]"
                                                @click="toggleRepGroup(repName)"
                                                @change="toggleRepGroup(repName)">
                                            </b-checkbox>
                                        </div>
                                        <div class="col-md-11 rep-toggle-checkbox">
                                            Select All Users for {{ repName }}
                                        </div>
                                    </div>
                                    <div v-for="user in users" :key="user.id+repName" class="row detail mb-2">
                                        <div class="col-md-1">
                                            <b-checkbox 
                                                v-model="selectedUserIds" 
                                                :value="user.id"
                                                :disabled="!user.privileges[privileges_to_check]">
                                            </b-checkbox>
                                        </div>
                                        <div class="col-md-6 link">
                                            <span class="member-name">{{user.name}}</span>
                                            <span v-if="user.company">({{user.company.name}})</span>
                                        </div>
                                        <div class="col-md-5">
                                            <template v-if="!user.privileges[privileges_to_check]">
                                                {{privileges_message}}
                                            </template>
                                        </div>
                                    </div>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
            
                </div>
            </div>
        </div>
        <div v-if="repList && repList.length" class="row">
            <div class="col-md-12">
                <div class="send-from-rep-wrapper">
                    <div class="col-md-6 send-from-rep">
                        <b-checkbox v-model="sendFromRep">Send from rep</b-checkbox>
                    </div>
                    <div class="col-md-6">
                        <b-select v-if="sendFromRep" v-model="fromRep" :options="repList" text-field="name" value-field="id">
                            <b-form-select-option :value="null" disabled>-- Select from rep --</b-form-select-option>
                        </b-select>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import {objLookup} from '../../util/common'
    import moment from 'moment'
    export default {
        props: [
            'vehicleIds',
            'value'
        ],
        created(){
            this.getUsers()
            this.getReps()
            if (this.$route.path === '/vehicle-stock/unsolds') {
                this.privileges_to_check = 'enable_unsold_stock_emails'
                this.privileges_message = 'Unsold stock emails disabled in profile'
            } else {
                this.privileges_to_check = 'enable_stock_emails'
                this.privileges_message = 'Stock emails disabled in profile'
            }
        },
        data() {
            return {
                sort_by: 'first_name',
                userType: 2,
                modalOpen: this.value,
                fields: [
                    {label: '',      key: 'checkbox'},
                    {label: 'Company',      key: 'company'},
                    {label: 'Name',         key: 'name'},
                    {label: 'Region',       key: 'region'},
                    {label: 'Assigned Rep', key: 'assignedrep'},
                ],
                notifyMessage: this.defaultMessage(),
                notifySubject: 'A world of choice! Vehicles in stock',
                selectedUserIds: [],
                userList: [],
                stockEnabledCount: 0,
                privileges_to_check: 'enable_stock_emails',
                privileges_message: 'Stock emails disabled in profile',
                filterByRep: false,
                repList: [],
                sendFromRep: false,
                fromRep: null,
                // users: [],
                repSelectAll: {},
            }
        },
        computed: {
            ...mapState({
                users: state => state.users.all,
                total: state => state.users.total,
            }),
            selectAll: {
                set() {
                    if (this.selectAll) {
                        this.selectedUserIds = []
                        // Uncheck all rep groups
                        Object.keys(this.repGroupedUsers).forEach(repName => {
                            this.$set(this.repSelectAll, repName, false);
                        });
                    } else {
                        let selected = []
                        this.userList.forEach(user => {
                            if (user.privileges[this.privileges_to_check]) {
                                selected.push(user.id)
                            }
                        })
                        this.selectedUserIds = selected
                        // Check all rep groups
                        Object.keys(this.repGroupedUsers).forEach(repName => {
                            this.$set(this.repSelectAll, repName, true);
                        });
                    }
                },
                get() {
                    return this.selectedUserIds.length === this.stockEnabledCount
                }
            },
            repGroupedUsers() {
                const groups = this.userList.reduce((groups, user) => {
                    const repName = user.sales_rep ? user.sales_rep.name : 'Unassigned';
                    if (!groups[repName]) {
                        groups[repName] = [];
                    }
                    groups[repName].push(user);
                    return groups;
                }, {});

                // order by rep name and then unassigned
                return Object.fromEntries(
                    Object.entries(groups)
                        .sort(([keyA], [keyB]) => {
                            if (keyA === 'Unassigned') return 1;
                            if (keyB === 'Unassigned') return -1;
                            return keyA.localeCompare(keyB);
                        })
                );
            }
        },
        watch: {
            value(){
                this.modalOpen = !!this.value;
            }
        },
        methods: {
            defaultMessage(){
                let msg = '';
                if (moment().hour() < 12) {
                    msg += 'Good morning,\n\n'
                } else {
                    msg += 'Good afternoon,\n\n'
                }
                msg += `We have some vehicles that may work for you. Get in touch with your SBL sales rep for more information on any of these vehicles. \n`
                return msg
            },
            async getUsers(){
                this.selectedUserIds = []
                this.userList = [];
                this.stockEnabledCount = 0
                await this.$store.dispatch('users/getUsers', {args: {
                        sort_by: 'company',
                        sort_asc: true,
                        per_page: 1000,
                        filter_by_statuses: [1,3],
                    }});
                if (this.users && this.users.length) {
                    this.users.forEach(user => {
                        if (user.privileges && user.privileges.enable_email) {
                            this.userList.push(user)
                            if (user.privileges[this.privileges_to_check]) {
                                this.stockEnabledCount++;
                            }
                        }
                    })
                    
                    // Initialize repSelectAll with all groups unchecked
                    Object.keys(this.repGroupedUsers).forEach(repName => {
                        this.$set(this.repSelectAll, repName, false);
                    });
                }
            },
            async getReps(){
                try {
                    const reps = await this.$store.dispatch('users/getUsers', {args:{
                            sort_by: 'company',
                            sort_asc: true,
                            per_page: 100,
                            filter_by_roles: [3, 4],
                        }});
                    if (reps && reps.data && reps.data.length) {
                        const repList = [];
                        reps.data.forEach(rep => {
                            if (rep.privileges && rep.privileges.enable_signature && rep.signature) {
                                repList.push(rep)
                            }
                        })
                        this.repList = repList;
                    }
                } catch (e) {
                    console.warn(e)
                }
            },
            async submit(){
                console.log('submit', this.notifySubject, this.notifyMessage)
                try{
                    await this.$store.dispatch('vehicleStock/sendStockEmail', {
                        vehicle_stock_ids: this.vehicleIds,
                        user_ids: this.selectedUserIds,
                        message: this.notifyMessage,
                        subject: this.notifySubject,
                        from_user: this.sendFromRep ? this.fromRep : null,
                    })
                    this.modalOpen = false
                    this.$message.success('The email was sent.')
                } catch (e) {
                    console.warn('Problem sending stock email', e)
                    this.$message.error('There was a problem sending the email.')
                }
            },
            objLookup(obj, key){
                return objLookup(obj, key);
            },
            onModalChange(){
                this.$emit('input', this.modalOpen);
                if (!this.modalOpen) {
                    // Clear selections when modal is closed
                    this.selectedUserIds = [];
                    // Reset rep group selections
                    Object.keys(this.repGroupedUsers).forEach(repName => {
                        this.$set(this.repSelectAll, repName, false);
                    });
                }
            },
            cancelModal() {
                this.modalOpen = false;
                // The onModalChange method will handle clearing selections
            },
            toggleRepGroup(repName) {
                const users = this.repGroupedUsers[repName];
                if (this.repSelectAll[repName]) {
                    // Select all enabled users in this group
                    users.forEach(user => {
                        if (user.privileges[this.privileges_to_check] && !this.selectedUserIds.includes(user.id)) {
                            this.selectedUserIds.push(user.id);
                        }
                    });
                } else {
                    // Deselect all users in this group
                    this.selectedUserIds = this.selectedUserIds.filter(id => 
                        !users.some(user => user.id === id)
                    );
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/VehicleStockSendEmail.vue